import Swal from 'sweetalert2';
import { makePDF } from '~core/makePDF';

export const printPDF = async () => {
  const pdf = await makePDF();

  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: "L'immagine &egrave; stata preparata per la stampa.",
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });

  pdf.autoPrint();
  window.open(pdf.output('bloburl'), '_blank');
};
